import styled from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

export const Wrapper = styled.div`
  display: flex;
  padding: 9px 24px;
`;

export const AddRssFeedBtn = styled(typography.BodyTextOneRegularTypography)`
  margin-inline-start: auto;
  padding: 8px 16px;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.primaryMain};
  border: 0px;
  border-radius: 4px;
  cursor: pointer;
`;
